let Fcm = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.sendNotification();
       this.validation();
    },

    sendNotification: function () {
        let sendFcmNotificationForm = $('#sendFcmNotificationForm');

        if (sendFcmNotificationForm.length) {
            let submitBtn = Ladda.create(sendFcmNotificationForm.find('[type=submit]')[0]);

            sendFcmNotificationForm.ajaxForm({
                beforeSubmit: function () {
                    if (!sendFcmNotificationForm.valid()) {
                        return false;
                    }
                    submitBtn.start();
                },

                success: function (response) {
                    submitBtn.stop();
                    if (response.success) {
                        sendFcmNotificationForm.resetForm();
                        toastr.success('Notification sent successfully!');

                        $('#fcmNotificationsTableContainer').html(response.content);
                        DataTables.fcmNotifications();
                    } else {
                        toastr.error(response.message);
                    }
                },

                error: function () {
                    submitBtn.stop();
                }
            });
        }
    },

    validation: function () {
        $('#sendFcmNotificationForm').validate({
            rules: {
                title: {
                    required: true,
                    minlength: 3,
                    maxlength: 50
                },
                message: {
                    required: true,
                    minlength: 3,
                    maxlength: 100
                }
            },
            submitHandler: function(form) {

            }

        })
    }
};

$().ready(function () {
    window.Fcm = Fcm;
    window.Fcm.init();
});